import { Heart } from 'lucide-react';
import { useLocation } from 'react-router-dom';

const STRIPE_DONATE_URL = 'https://buy.stripe.com/14A00k0pAf8ldE7byBfMA01';

const DonateButton = () => {
  const location = useLocation();

  // Hide on shop pages where the cart FAB occupies the same position
  if (location.pathname.startsWith('/shop')) return null;

  return (
    <a
      href={STRIPE_DONATE_URL}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 right-6 z-50 flex items-center gap-2 bg-brand-gold text-brand-dark px-5 py-3 shadow-lg hover:shadow-xl transition-all hover:scale-105 font-semibold text-sm"
      data-testid="floating-donate-btn"
    >
      <Heart className="w-4 h-4" />
      Donate
    </a>
  );
};

export default DonateButton;
